import type { ComponentType } from 'react';

/**
 * After a deploy, long-lived tabs can still run an old main bundle that lazy-imports
 * chunk URLs which no longer exist on Hosting (rewrite serves index.html → MIME error).
 * Reload once so the tab picks up fresh index.html + matching hashed assets.
 */
const CHUNK_RELOAD_SESSION_KEY = 'nidata_chunk_reload_once';

export function safeLazyImport<T extends { default: ComponentType<unknown> }>(
  importFn: () => Promise<T>,
): () => Promise<T> {
  return async () => {
    try {
      const mod = await importFn();
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
      }
      return mod;
    } catch {
      if (typeof sessionStorage === 'undefined') {
        throw new Error('Dynamic import failed');
      }
      if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1') {
        throw new Error('Dynamic import failed after reload');
      }
      sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
      window.location.reload();
      return new Promise(() => {});
    }
  };
}
